



































































































































































































import { Vue, Component } from 'vue-property-decorator'
import {
  IPrivateAccount,
  getAccountStatus,
  getAccountList,
  getAccountArea,
  addEditAccount,
  deleteAccount,
  setAccountUsed
} from '@/api/developer/developer-private/private'
import {
  formatJson,
  resetObjValue2NoneString,
  checkNoneString,
  deepCopy,
  copyFields
} from '@/utils/tool'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { EApprovalColor } from '@/typings/enum'
import ApprovalPopup from './components/approval-popup.vue'

type actStatus = 'open' | 'close'
interface info {
    applicant: string,
    type: string,
    typeId: number,
    status: string,
    statusId: number
  }

const statisticList = [
  {
    name: '待审核',
    count: 1256
  },
  {
    name: '已审核',
    count: 43
  }
]
const typeList = [
  {
    id: 1,
    name: '应用信息审核'
  },
  {
    id: 2,
    name: '权限审核'
  },
  {
    id: 3,
    name: '上架应用审核'
  }
]
const statusList = [
  {
    'id': 1,
    'name': '待审核'
  },
  {
    'id': 2,
    'name': '审核中'
  },
  {
    'id': 3,
    'name': '审核通过'
  },
  {
    'id': 4,
    'name': '审核不通过'
  }
]

@Component({
  name: 'ApprovalList',
  components: {
    ApprovalPopup
  }
})
export default class extends mixins(DateOption) {
  // api data
  params = {
    id: '',
    applicant: '',
    status: '',
    type: '',
    applyDateStart: '',
    applyDateEnd: '',
    page: 1,
    pageCount: 20
  }

  // component data
  stateColor = EApprovalColor
  statisticList = statisticList
  tableLoading = false
  tableData: any[] = []
  typeList: any[] = typeList
  statusList: any[] = statusList
  dateArray: string[] = ['', '']
  totalCount = 0

  approveInfo:info = {
    applicant: '',
    type: '',
    typeId: 1,
    status: '',
    statusId: 1
  }
  tableHeight: number = 500
  visible = false

  // lifecycle
  async created() {
    this.getTableData()
  }
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 290 - filterDom.clientHeight
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    // let res = await getAccountList(this.params)

    this.tableData.push({
      id: 1,
      typeId: 1,
      type: '应用信息审核',
      statusId: 1,
      status: '待审核',
      applyDate: '2019-11-11 11:11:11',
      applicant: 'Mr Huhua'
    }, {
      id: 2,
      typeId: 2,
      type: '上架应用审核',
      statusId: 2,
      status: '审核中',
      applyDate: '2019-11-11 11:11:11',
      applicant: 'Mr Huhua'
    }, {
      id: 3,
      typeId: 3,
      type: '下架应用审核',
      statusId: 3,
      status: '审核通过',
      applyDate: '2019-11-11 11:11:11',
      applicant: 'Mr Huhua'
    }, {
      id: 4,
      typeId: 4,
      type: '权限审核',
      statusId: 4,
      status: '审核不通过',
      applyDate: '2019-11-11 11:11:11',
      applicant: 'Mr Huhua'
    })
    this.tableLoading = false
    // this.tableData = res.data.dataList
    // this.totalCount = res.data.pageInfo.totalCount
  }

  handleDateChange(date: string[]) {
    this.params.applyDateStart = date && date[0]
    this.params.applyDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArray = ['', '']
    this.params.page = 1
  }

  handleView(item: info) {
    this.visible = true
    copyFields(this.approveInfo, item)
  }
}
